import { PrimaryWeapon } from './primaryWeapon';
import { IColumnModel, ColumnModel } from 'table-editor';
import { StarbaseEntity, Serializable } from 'starbase-launcher';

export class Weapon extends StarbaseEntity implements Serializable<Weapon> {
  public primaryWeaponUID: number;
  public primaryWeapon?: any;
  public secondaryWeapon: string;

  /** Alias to secondaryWeapon property */
  public weapon: string;
  public weaponDisplay: string;

  /** Alias to primaryWeapon.weapon_Category property */
  public weapon_Category: string;
  public editMode: boolean;
  public editable: boolean;

  constructor() {
    super();
  }


  public static WeaponColumnData(primaryWeapons: PrimaryWeapon[], editable: boolean = false): IColumnModel[] {
    return [
      new ColumnModel('UID', 'uid', 'UID', false, 'number', false, true, 10, false),
      new ColumnModel('Weapon Category', 'primaryWeapon', 'PrimaryWeapon', editable, 'dropdown', true, true, 30, false, primaryWeapons, 'weapon_Category'),
      new ColumnModel('Weapon', 'secondaryWeapon', 'SecondaryWeapon', editable, 'typeahead', false, false, 250, true),
      new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, true, 50, false),
      new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, true, 50, false)
    ];
  }
  // TODO: further optimize the other setupXCollection methods this way
  public static setupWeaponCollection(collection: Weapon[]): Weapon[] {
    return collection.map((k: Weapon, i, arr) => {
      k.primaryWeapon = new PrimaryWeapon().deserialize(k.primaryWeapon);
      k.weapon_Category = k.primaryWeapon.weapon_Category;
      // k.weaponDisplay = k.primaryWeapon.weapon_Category + ' : ' + k.weapon;
      k = new Weapon().deserialize(k);
      return k;
    });
  }

  public deserialize(input) {
    const w: Weapon = Object.assign(new Weapon(), input);
    w.weaponDisplay = w.concatWeaponName();
    w.weapon = w.secondaryWeapon;
    return w;
  }

  public concatWeaponName(): string {
    return this.primaryWeapon.weapon_Category + ' : ' + this.weapon;
  }
}
